var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Instance',{attrs:{"instance":"company","instance-name":"Company","create":(d) => _vm.company.create(d),"delete":(d) => _vm.company.remove(d),"update":(d) => _vm.company.update(d),"get":(d) => _vm.company.get(d),"upsert":_vm.upsert,"columns":_vm.columns,"header":false,"headerBg":"#ffffff"}})
}
var staticRenderFns = []

export { render, staticRenderFns }